import React from 'react';
import { Button, message, Popconfirm } from 'antd';
import UserStore from 'stores/UserStore';

interface IProps {
    id: number;
    handleRemove: (id: number) => void;
    email: string;
}

const Remove: React.FC<IProps> = props => {
    const handleClick = () => {
        UserStore.removeEmail(props.id)
            .then(() => {
                props.handleRemove(props.id);
            })
            .catch(() => {
                message.error('Error');
            });
    };

    return (
        <>
            <Popconfirm
                title={`Are you sure you want to remove ${props.email}?`}
                onConfirm={handleClick}
                okText="Yes"
                cancelText="No"
            >
                <Button size="small" className="ant-btn-xs">
                    Remove
                </Button>
            </Popconfirm>
        </>
    );
};

export default Remove;
